import { Localizations } from '@eig-builder/module-localization'

Localizations.append({
  modules: {
    crm: {
      components: {
        account: {
          acceptedTerms: 'Accepted Terms on {0}',
          overrideDomain: 'Are you sure you want to override the domain purchase block?',
          overrideMail: 'Are you sure you want to override the mail purchase block?',
          overridePaymentMethod: 'Are you sure you want to override the change payment method block?',
          override: 'Override Fraud Block',
          cancelAccount: 'Cancel Account',
          changeEmail: 'Change Email',
          changeEmailSuccess: 'Email was changed succesfully.',
          changeEmailPending: 'Please wait while your request is being processed.',
          manageSubscriptions: 'Manage Subscriptions',
          suspicious: 'This account has been flagged as being suspicious. ',
          migrated: 'Customer migrated to JustHost on {0}',
          migratedFrom: 'Customer migrated from {0} on {1}',
          login: 'Login',
          manageServices: 'Manage Services',
          billingClient: 'Billing Client',
          restoreAccount: 'Restore Account',
          allowDomain: 'Allow Domain Purchases',
          allowMail: 'Allow Mail Purchases',
          allowChangePaymentMethod: 'Allow Change Payment Method',
          allowDomainError:
            'An error occurred while trying to allow this account to override the domain purchase block',
          allowMailError: 'An error occurred while trying to allow this account to override the mail purchase block',
          allowChangePaymentMethodError:
            'An error occurred while trying to allow this account to override the change payment method block',
          allowDomainResponse: 'This account is now allowed to override the domain purchase block',
          allowMailResponse: 'This account is now allowed to override the mail purchase block',
          allowChangePaymentMethodResponse: 'This account is now allowed to override the change payment method block',
          accountSuccess: 'Successfully updated account',
          accountError: 'Error updating account',
          close: 'Close',
          eventInformation: 'Event Information',
          synchronizeCards: 'Synchronize CreditCards',
          synchronizeCardsPending: 'Please wait while credits cards are being synchronized.',
          synchronizeCardsResponse: 'CreditCards have been updated.',
          sendSinglePlatformMailTitle: 'Send SP Mail',
          sendConstantContactMailTitle: 'Send CTCT Mail',
          sendExternalMailTitle: 'Send Mail',
          sendExternalMailSubtitle: 'Select the type of email you would like to send to the customer for this site.',
          singlePlatformCustomer: 'Single Platform Customer',
          constantContactCustomer: 'Constant Contact Customer',
          freeDomainAllowance: 'Free Domain Allowance: ',
          freeEmailAllowance: 'Free Email Allowance: ',
          created: 'Created',
          accountId: 'Account ID',
          billingId: 'Billing ID',
          last4Digits: 'CC Last 4 Digits',
          noSites: 'No sites found.',
          action: 'Action',
          name: 'Name',
          type: 'Type',
          deleted: 'Deleted',
          domainExpiry: 'Domain Expiry',
          published: 'Published',
          templateId: 'Template ID',
          traditional: 'Traditional',
          express: 'Express',
          plan: 'Plan',
          id: 'ID',
          billingOrderId: 'Billing Order ID',
          status: 'Status',
          actions: 'Actions',
          noOrders: 'No orders found.',
          completedOrders: 'Completed orders',
          pendingOrders: 'Pending orders',
          cancelledOrders: 'Cancelled orders',
          noEmails: 'No emails found.',
          email: 'Email',
          billingServiceId: 'Billing Service ID',
          noCpanelSites: 'No cPanel sites found',
          stats: {
            recent: 'Stats (last 30 days)',
            visitors: 'Visitors: {0}',
            siteVisits: 'Visits: {0}',
            pageviews: 'Pageviews: {0}',
            storeSales: 'Store sales: {0}',
            formSubmissions: 'Form submissions: {0}'
          },
          insights: 'Insights',
          copySite: 'Copy site',
          env: 'Environment',
          selectEnv: 'Select the environment that you want to copy the site to.',
          partner: 'Partner',
          cancel: 'Cancel',
          submit: 'Submit',
          emailLabel: 'Email (optional)',
          brand: 'Brand (optional)',
          copyAccountLookup: 'You can enter the Account ID manually, or do a lookup on email address and brand.',
          getAccountId: 'Get Account ID',
          accountIdInfo: 'Enter the account id where you want to copy the site to.',
          partnerIdInfo: 'Select the partner that is corresponding to the entered account id.',
          moveServiceTitle: 'Move service to site: {0}',
          activeServices: 'Active services',
          cancelledServices: 'Cancelled services',
          moveService: 'Move service',
          service: 'Service',
          noServicesToMove: 'There are no services available to move to this {0}.',
          move: 'Move',
          removeFreeDomainCredit: 'Remove Free Domain Credit',
          loading: 'Loading...',
          fixGsuiteIssue: 'Fix Gsuite Issue',
          viewInrosetta: 'View in rosseta',
          specificError: 'ERROR: {0}',
          generalError: 'Something went wrong...',
          affiliateInfo: {
            title: 'Affiliate info',
            mediaPartner: 'Media Partner:',
            mediaPartnerId: 'Media Partner Id:',
            refId: 'Referral Id:'
          },
          restoreAccountSuccess: 'The account has been restored.',
          loadAccountError: 'Failed to load the account information.'
        }
      }
    }
  }
})
